
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

const DEFAULT_PROGRESS_ELEMENT_WIDTH = 200;
const DEFAULT_THICKNESS = 15;
function isInProgress(percentage) {
  return percentage > 0 && percentage < 100;
}
function isComplete(percentage) {
  return percentage >= 100;
}
function isNotStarted(percentage) {
  return percentage <= 0;
}
function getRelativeThickness({
  thickness,
  width
} = {}) {
  if (thickness) {
    return (thickness / width * 100).toFixed(1);
  }

  const relWidth = width / DEFAULT_PROGRESS_ELEMENT_WIDTH;
  const relThick = DEFAULT_THICKNESS * relWidth;
  return (relThick / width * 100).toFixed(1);
}
function getRelativeStrokeWidth({
  strokeWidth,
  width
}) {
  return (strokeWidth / width * 100).toFixed(1);
}
function getTrickleProgress(num) {
  if (num >= 0 && num < 20) {
    return 10;
  }

  if (num >= 20 && num < 50) {
    return 4;
  }

  if (num >= 50 && num < 80) {
    return 2;
  }

  if (num >= 80 && num < 99) {
    return 0.5;
  }

  return 0;
}
const queue = function () {
  const pending = [];

  function next() {
    const fn = pending.shift();

    if (fn) {
      fn(next);
    }
  }

  return function (fn) {
    pending.push(fn);

    if (pending.length === 1) {
      next();
    }
  };
}();

export { getRelativeThickness as a, isComplete as b, isNotStarted as c, getTrickleProgress as d, getRelativeStrokeWidth as g, isInProgress as i, queue as q };
